// ─────────────────────────────────────────────────────────────────────────────
// StatCard.js — a single KPI tile in the top stats row.
// ─────────────────────────────────────────────────────────────────────────────
import styles from "./StatCard.module.css";

/**
 * @param {object}  props
 * @param {ReactNode} props.icon       glyph rendered in the top-right chip
 * @param {string}  props.label        uppercase caption
 * @param {ReactNode} props.value      large primary value
 * @param {ReactNode} props.unit       optional small unit after the value (e.g. "Gbps")
 * @param {ReactNode} props.trendIcon  small glyph before the sub-line
 * @param {string}  props.sub          sub-line text
 * @param {string}  props.accent       accent color for icon + trend
 * @param {boolean} props.highlight    draws the accented "primary" border
 * @param {number}  props.delay        stagger animation delay (ms)
 */
export default function StatCard({
  icon, label, value, unit, trendIcon, sub, accent = "var(--accent)", highlight = false, delay = 0,
}) {
  return (
    <div
      className={`${styles.card} ${highlight ? styles.highlight : ""}`}
      style={{ animationDelay: `${delay}ms`, "--stat-accent": accent }}
    >
      <div className={styles.top}>
        <span className={styles.label}>{label}</span>
        <span className={styles.iconChip}>{icon}</span>
      </div>

      <div className={styles.value}>
        {value}
        {unit && <span className={styles.unit}>{unit}</span>}
      </div>

      <div className={styles.sub}>
        {trendIcon && <span className={styles.trendIcon}>{trendIcon}</span>}
        {sub}
      </div>

      <span className={styles.glow} />
    </div>
  );
}
